var render = function render(){var _vm=this,_c=_vm._self._c;return _c('block',{attrs:{"title":"热门行业"}},[_c('v-chart',{staticClass:"chart",attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }